// Logout reason constants
export const LOGOUT_REASONS = {
  USER_CLICKED_LOGOUT: 'user_clicked_logout',
  SESSION_EXPIRY_MODAL_LOGOUT: 'session_expiry_modal_logout_click',
  TOKEN_EXPIRED_AUTOMATIC_AFTER_PROMPT: 'token_expired_automatic_after_prompt',
  TOKEN_EXPIRED: 'token_expired'
};

